import auth from "@/api/auth";

const state = {
    user: null,
    token: ""
};

const getters = {
    token: state => {
        return state.token;
    },
    user: state => {
        return state.user;
    }
};

const actions = {
    login({ commit }, data) {
        return auth
            .login(data)
            .then(response => {
                if (response.status === 200) {
                    commit("SET_TOKEN", response.data.access_token);
                }
                return response;
            })
            .catch(error => {
                console.log("error " + error);
                return error;
            });
    },

    user({ commit }) {
        return auth
            .user()
            .then(({ data, status }) => {
                if (status === 200) {
                    commit("SET_USER", data.data);
                }
                return data;
            })
            .catch(error => {
                console.log("error " + error);
                return error;
            });
    },

    logout({ commit }) {
        commit("SET_TOKEN", null);
        commit("SET_USER", null);
    }
};

const mutations = {
    SET_TOKEN(state, value) {
        state.token = value;
    },
    SET_USER(state, value) {
        state.user = value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
